export const C115B_LAYER_BADGE = 'Gas waste / flaring';

export const C115B_SHORT_BADGE = 'Gas waste';

export const C115B_COMPANION_COPY =
  'Reported C-115B natural gas waste records from NM OCD. Not live sensor data.';

export const c115bFreshTooltip = (latestPeriod: string | null | undefined): string =>
  `Live from NM OCD C-115B records. Reported monthly; latest period ${latestPeriod || '—'}.`;

export const c115bEmptyState = (period: string | null | undefined): string =>
  `No C-115B gas waste records reported for the selected area in ${period || '—'}.`;

export const C115B_MISSING_TOOLTIP = 'NM OCD C-115B feed is unavailable right now.';
